import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "@/components/layout/MainLayout";
import { Button } from "@/components/ui/button";
import { CheckCircle, ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

const PaymentResult = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  // Получаем все параметры из URL
  const searchParams = new URLSearchParams(location.search);
  const params: Record<string, string> = {};

  // Преобразуем параметры в объект для удобного отображения
  searchParams.forEach((value, key) => {
    params[key] = value;
  });

  // Проверяем, есть ли параметры
  const hasParams = Object.keys(params).length > 0;

  return (
    <MainLayout>
      <div className="container-page max-w-3xl mx-auto py-8">
        <Button
          variant="ghost"
          className="mb-6"
          onClick={() => navigate("/balance")}
        >
          <ArrowLeft size={16} className="mr-2" />
          <span>{t('payment_result.back_to_balance')}</span>
        </Button>

        <div className="bg-card border rounded-lg p-8 shadow-sm">
          <div className="flex items-center justify-center mb-6">
            <div className="h-16 w-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center">
              <CheckCircle size={32} />
            </div>
          </div>

          <h1 className="text-2xl font-bold text-center mb-2">{t('payment_result.title')}</h1>
          <p className="text-muted-foreground text-center mb-8">
            {t('payment_result.description')}
          </p>

          {hasParams ? (
            <div className="border rounded-lg overflow-hidden mb-8">
              <div className="bg-muted px-4 py-3 border-b">
                <h2 className="font-medium">{t('payment_result.params_title')}</h2>
              </div>
              <div className="divide-y">
                {Object.entries(params).map(([key, value]) => (
                  <div key={key} className="px-4 py-3 flex justify-between">
                    <span className="font-medium text-foreground">{key}</span>
                    <span className="text-muted-foreground">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-8">

            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button onClick={() => navigate("/")}>
              {t('payment_result.start_using')}
            </Button>
            <Button variant="outline" onClick={() => navigate("/balance")}>
              {t('payment_result.back_to_balance')}
            </Button>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default PaymentResult;